module.exports = __webpack_public_path__ + "img/item_Character_fluid_02b.cce05d9b.jpeg";